<template></template>

<script setup>
const { locale } = useI18n();
const props = defineProps({
	error: {
		type: Object, default: null
	}
});

const statusCode = props.error.statusCode;
const redirectUrl = locale.value === 'en' ? `/en/${statusCode}` : `/${statusCode}`;

await navigateTo(redirectUrl, {
	redirectCode: 301,
	replace: true
});
</script>

<style lang="scss">
@use '~/assets/scss/page/error' as *;
</style>